import Link from 'next/link'
import { Anchor } from 'lucide-react'
import { Button } from '@/components/ui/button'

export function NotFoundPage() {
  return (
    <div className="flex min-h-[360px] flex-col items-center justify-center gap-4 text-center">
      <Anchor className="h-10 w-10 text-muted-foreground" />
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Page not found</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          This Helm route is not available.
        </p>
      </div>
      <Link href="/">
        <Button>Open Dashboard</Button>
      </Link>
    </div>
  )
}
